<template>
  <el-dialog class="dialog-edit-role" :title="title" :visible.sync="visible" width="400px">
    <ConfigForms ref="form" labelWidth="110px" :formItems="formItems" :data="formData" inline />
    <span slot="footer" class="dialog-footer">
      <el-button @click="close" size="small">取 消</el-button>
      <el-button type="primary" @click="sure" size="small">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ConfigForms from '@/components/config-forms';
import { aiTemplateCategoryTypes } from '../config';

const formItems = [
  { type: 'text', label: '名称', required: true, key: 'name' },
  { type: 'number', label: '排序', required: true, key: 'rank' },
  { type: 'switch', label: '状态', required: true, key: 'status' },
  { type: 'select', label: '模版类型', required: true, key: 'templateType', options: aiTemplateCategoryTypes },
]
export default {
  name: 'EditTemplateCategory',
  emit: ['close'],
  components: { ConfigForms },
  data() {
    return {
      visible: false,
      formItems,
      formData: null,
    };
  },
  watch: {
  },
  computed: {
    isEdit() {
      return !!this.formData
    },
    title() {
      return this.isEdit ? '编辑AI模版分类' : '新增AI模版分类'
    }
  },
  created() {

  },
  methods: {
    close() {
      this.visible = false
    },
    open(row) {
      this.formData = null
      if (row) {
        // TODO：参数待完善
        this.formData = { ...row }
      }
      this.visible = true
    },
    async sure() {
      try {
        const form = await this.$refs.form.validate();
        const data = { ...form }
        this.$emit('sure', { isEdit: this.isEdit, data })
      } catch (error) {
        console.error('sure error:', error);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.dialog-edit-role {
  /deep/ .el-date-editor.el-input {
    width: 200px;

  }
}
</style>
